export const styles = {
  inputLabel: {
    display: 'flex',
    mb: '8px',
  },
};
